import { render } from "./PartnerManageListPage.vue?vue&type=template&id=0ec72d72&lang=true"
import script from "./PartnerManageListPage.vue?vue&type=script&lang=js"
export * from "./PartnerManageListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__